import * as THREE from 'three';
import { GLTFExporter } from 'three/addons/exporters/GLTFExporter.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js';
import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js';

export const exportToGLTFAndLoadModel = async (model: THREE.Object3D | THREE.Group) => {
    const exporter = new GLTFExporter();

    try {
        const gltf = await exporter.parseAsync(model);
        //const blob = new Blob([JSON.stringify(gltf)], { type: 'text/plain' });
        //const gltfFile = new File([blob], `${model.name}.gltf`, { type: 'text/plain' });
        
        const manager = new THREE.LoadingManager();

        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath(`${process.env.REACT_APP_ORIGIN}/libs/draco/gltf/`);

        const ktx2Loader = new KTX2Loader(manager);
        ktx2Loader.setTranscoderPath(`${process.env.REACT_APP_ORIGIN}/libs/basis/`);

        const loader = new GLTFLoader(manager);
        loader.setDRACOLoader(dracoLoader);
        loader.setKTX2Loader(ktx2Loader);
        loader.setMeshoptDecoder(MeshoptDecoder);

        return await loader.parseAsync(gltf as ArrayBuffer, '');

    } catch (error) {
        return undefined;
    }
};